import nodeClient from "./node-client";

export const saveManufacturerGroup = async (payload) => {
  const response = await nodeClient.post(
    `/service/private/v0/manufacturer/group/add`,
    payload
  );
  return response?.data?.result;
};

export const searchManufacturerGroup = async (payload) => {
  const response = await nodeClient.post(
    `/service/protected/v0/manufacturer/group/list`,
    payload
  );
  return response?.data?.result?.rows || [];
};
